export const pagesData = [
  {
    key: "1",
    PAGE: "Home",
    PAGESLUG: "/home",
    LASTUPDATED: "24 Jan 2025",
    STATUS: "Published",
  },
  {
    key: "2",
    PAGE: "About Us",
    PAGESLUG: "/about-us",
    LASTUPDATED: "19 Dec 2024",
    STATUS: "Unpublish",
  },
  {
    key: "3",
    PAGE: "Contact",
    PAGESLUG: "/contact",
    LASTUPDATED: "11 Dec 2024",
    STATUS: "Published",
  },
  {
    key: "4",
    PAGE: "Blog",
    PAGESLUG: "/blog",
    LASTUPDATED: "29 Nov 2024",
    STATUS: "Published",
  },
  {
    key: "5",
    PAGE: "FAQ",
    PAGESLUG: "/faq",
    LASTUPDATED: "03 Nov 2024",
    STATUS: "Published",
  },
  {
    key: "6",
    PAGE: "Privacy Policy",
    PAGESLUG: "/privacy-policy",
    LASTUPDATED: "31 Oct 2024",
    STATUS: "Unpublish",
  },
  {
    key: "7",
    PAGE: "Terms & Conditions",
    PAGESLUG: "/terms",
    LASTUPDATED: "15 Oct 2024",
    STATUS: "Unpublish",
  },
  {
    key: "8",
    PAGE: "Support",
    PAGESLUG: "/support",
    LASTUPDATED: "26 Sep 2024",
    STATUS: "Published",
  },
  {
    key: "9",
    PAGE: "Testimonials",
    PAGESLUG: "/testimonials",
    LASTUPDATED: "01 Sep 2024",
    STATUS: "Published",
  },
  {
    key: "10",
    PAGE: "Rental Policies",
    PAGESLUG: "/rental-policy",
    LASTUPDATED: "15 Aug 2024",
    STATUS: "Published",
  },
];
